export class StringFunctions {
	// static newRandomString(length = 6 ) {
	// 	let text = '';
	// 	const possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
	//
	// 	for ( let i = 0; i < length; i++ ) {
	// 		text += possible.charAt(Math.floor(Math.random() * possible.length));
	// 	}
	// 	return text;
	// }

	static emptyToNull(stringToBeChecked: string): string {
		return (stringToBeChecked && stringToBeChecked.length > 0) ? stringToBeChecked : null;
	}
}
